/*! @azure/msal-common v15.12.0 2025-08-27 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.12.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
